import React, { useRef, useState, useEffect } from 'react';

import cn from 'classnames';
import Lottie from 'lottie-react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';

import cls from './AILoader.module.css';
// @ts-ignore
import mainAnimation from './assets/MainAnimation.json';

interface AILoaderProps {
    loaderTextsProp?: string[];
}

export const AILoader = ({ loaderTextsProp }: AILoaderProps) => {
    const nodeRef = useRef(null);
    const [index, setIndex] = useState(0);
    const [visible, setVisible] = useState(true);
    const { t } = useTranslation();
    const loaderTexts = loaderTextsProp || [
        t('AILoader.loaderTexts.one'),
        t('AILoader.loaderTexts.two'),
        t('AILoader.loaderTexts.three'),
        t('AILoader.loaderTexts.four'),
        t('AILoader.loaderTexts.five'),
        t('AILoader.loaderTexts.six'),
        t('AILoader.loaderTexts.seven'),
    ];

    useEffect(() => {
        const html = document.documentElement;
        const hasVerticalScrollbar =
            document.documentElement.scrollHeight > document.documentElement.clientHeight;

        const originalBodyOverflow = document.body.style.overflow;
        const originalHtmlOverflow = html.style.overflow;
        const originalScrollBarGutter = html.style.scrollbarGutter;
        const originalBackground = html.style.background;

        if (hasVerticalScrollbar) {
            html.style.scrollbarGutter = 'stable';
        }

        document.body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        html.style.background = 'rgb(0 0 0 / 40%)';

        return () => {
            document.body.style.overflow = originalBodyOverflow;
            html.style.overflow = originalHtmlOverflow;
            html.style.scrollbarGutter = originalScrollBarGutter;
            html.style.background = originalBackground;
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setVisible(false);

            setTimeout(() => {
                setIndex((prev) => (prev + 1) % loaderTexts.length);
                setVisible(true);
            }, 400);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return ReactDOM.createPortal(
        <CSSTransition
            in
            timeout={300}
            classNames={{
                enter: cls.AILoaderEnter,
                enterActive: cls.AILoaderEnterActive,
                exit: cls.AILoaderExit,
                exitActive: cls.AILoaderExitActive,
            }}
            unmountOnExit
            nodeRef={nodeRef}
        >
            <div className={cn(cls.AILoader)} ref={nodeRef}>
                <div className={cls.AILoaderOverlay}>
                    <div className={cls.AILoaderContent}>
                        <Lottie
                            animationData={mainAnimation}
                            loop
                            autoplay
                            style={{ width: 44, height: 44 }}
                        />
                        <span
                            className={cn(
                                cls.LoaderText,
                                visible ? cls.TextVisible : cls.TextHidden
                            )}
                        >
                            {loaderTexts[index]}
                        </span>
                    </div>
                </div>
            </div>
        </CSSTransition>,
        document.body
    );
};
